// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ProjectUserRole,
  InvitationStatus,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  projectId: __t.u32().name("project_id"),
  userIdentity: __t.identity().name("user_identity"),
  get role() {
    return ProjectUserRole;
  },
  get status() {
    return InvitationStatus;
  },
  invitedAt: __t.timestamp().name("invited_at"),
  invitedBy: __t.identity().name("invited_by"),
  respondedAt: __t.option(__t.timestamp()).name("responded_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  email: __t.option(__t.string()),
});
